import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { Injectable } from "@angular/core";
import { BfxBlotterFilterService } from "../../bfx-blotter-filter/bfx-blotter-filter.service";
import { BfxBlotterFilter } from "../../bfx-blotter-filter/bfx-blotter-filter.constants";
import { BfxSoundsService } from "../../bfx-common/services/bfx-sounds.service";
import {
  ActiveUserProfilePromiseService,
  SystemConfigPromiseService,
  INotificationEvent,
} from "shared/cubiq-services";
import { TranslateService } from "@ngx-translate/core";
import { BfxOrderBlotterFilteringService } from "../../bfx-blotter-orders/bfx-blotter-orders-filter.service";
import {
  BfxApplicationNotificationData,
  NOTIF_SORT,
} from "../models/bfx-application-notification-data.model";
import { Subject, Subscription } from "rxjs";
import { BfxBlotterOrdersActionService } from "../../bfx-blotter-orders/bfx-blotter-orders-action.service";
import { BfxBlotterActionEvent } from "app/bfx-base-blotter/bfx-base-blotter-contextmenu.service";
import { BfxBlotterAction } from "shared/cubiq-services/model/contextmenu/bfx-base-blotter/BfxBlotterAction";
// import { forEach } from '@angular/router/utils/collection';//MARKED FOR REMOVAL ANGULAR UPGRADE
import { OrderDataImpl } from "shared/cubiq-model-multi-asset";

import { BfxAppNotificatonSettingsService } from "../../bfx-common/services/bfx-app-notifications-settings.service";
import { Router } from "@angular/router";
import { BfxAppEventSetting } from "../../bfx-user-settings/model/bfx-app-event-setting";
import { BfxApplicationNotificationCommand } from "../models/bfx-application-notification-command.enum";
import * as CubiqServices from "shared/cubiq-services";
import { BfxBlotterTradeFilterService } from "../../bfx-blotter-trade/services/bfx-blotter-trade-filter.service";
import { BfxTradeActionsService } from "../../bfx-blotter-trade/services/bfx-trade-actions.service";

//activated, cancelled, expired, filled, modified, suspended
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { BFXAppNotificationType } from "../../../shared/cubiq-services/model/core/notifications/BFXAppNotificationType";
import { BFXNotificationType } from "../../../shared/cubiq-services/model/core/notifications/BFXNotificationType";
import { BFXNotificationSubType } from "../../../shared/cubiq-services/model/core/notifications/BFXNotificationSubType";
import { BFXAppNotificationSubType } from "../../../shared/cubiq-services/model/core/notifications/BFXAppNotificationSubType";
import { NotificationService } from "shared/cubiq-services/lookup/notification/impl/NotificationService";
import { BFXAppNotificationEventType } from "../../../shared/cubiq-services/model/core/notifications/BFXAppNotificationEventType";
import { BmarkClientOrdersFilterService } from "app/bfx-bmark-summary/blotters/client-orders/services/bmark-client-orders-filter.service";
import { OrderTypeHelper } from "shared/cubiq-services/model/orders/OrderTypeHelper";
import { BfxConfigService, BfxSysConfigUtilService } from "shared/auth-services";
import { BfxUIConfiguration } from "shared/auth-services/system-config/model/config.models";
import { BfxApplicationSettingProviderService } from "app/bfx-notification-application/services/bfx-application-setting-provider.service";

export const DEFAULT_APP_NOTIF_SOUND_THROTTLE: number = 15000;

@Injectable()
export class BfxApplicationNotificationService {
  public notifications: Array<BfxApplicationNotificationData> = [];
  private routeSubscription: Subscription;
  private orderUpdateSubscription: Subscription;
  private dealUpdateSubscription: Subscription;
  private pagResetCallback: Function;
  private orderTypeHelper: OrderTypeHelper;

  //************************/
  //* Notification Counter */
  //************************/
  private _notifyCounterSubject = new Subject<{ notifCounter: number }>();
  public notifyCounter$ = this._notifyCounterSubject.asObservable();

  //*****/
  private activeUser: CubiqServices.ActiveUser;
  private bmarkLongName: string;
  private bmarkShortName: string;

  private soundThrottleInterval: number = DEFAULT_APP_NOTIF_SOUND_THROTTLE;
  private appNotifAudioTimestamps: any = {};

  constructor(
    // private factoryResolver: ComponentFactoryResolver,
    private _router: Router,
    protected systemConfigService: SystemConfigPromiseService,
    private activeUserService: ActiveUserProfilePromiseService,
    private translationService: TranslateService,
    private appNotificationSettingsService: BfxAppNotificatonSettingsService,
    private filterService: BfxBlotterFilterService,
    private soundsService: BfxSoundsService,
    private orderFilteringService: BfxOrderBlotterFilteringService,
    private dealFilteringService: BfxBlotterTradeFilterService,
    private blotterOrderActionService: BfxBlotterOrdersActionService,
    private blotterTradeActionService: BfxTradeActionsService,
    private notificationService: NotificationService,
    private bmarkClientOrdersFilterService: BmarkClientOrdersFilterService,
    protected _algoStrategyLookup: CubiqServices.AlgoStrategyLookupService,
    public configService: BfxConfigService,
    private appSettingProviderService: BfxApplicationSettingProviderService,
    protected sysConfigUtil?: BfxSysConfigUtilService,
  ) {
    this.getSystemFlagsAndRolesForActions().then((actionData) => {
      this.activeUserService.getActiveUserData().then((data: CubiqServices.ActiveUser) => {
        this.activeUser = data;
        this.appSettingProviderService.ready.then(() => {
          this.initializeNotificationSubscriptions();
          this.loadLoginNotifications();
        });
      });

      this.loadAudioThrottleConfig();
    });

    this.orderTypeHelper = new OrderTypeHelper("", this._algoStrategyLookup, this.sysConfigUtil);

    // need a more global solution to this, worker and services should really be getting destroyed
    this.routeSubscription = this._router.events.subscribe((url: any) => {
      if (_router.url == "/logout") {
        this.closeAllNotifications();
        this.routeSubscription.unsubscribe();
        if (this.orderUpdateSubscription != null) this.orderUpdateSubscription.unsubscribe();

        if (this.dealUpdateSubscription != null) this.dealUpdateSubscription.unsubscribe();
      }
    });
  }

  /**
   * Find out what login notifications types are required, then request them from the server
   */
  private loadLoginNotifications() {
    // Get set of login notifcation types to load
    const loginTypes = this.appSettingProviderService.getLoginTypes();
    let ds: Array<CubiqTS.ApplicationNotificationFetchDescriptorImpl> = [];
    for (const eventType of loginTypes) {
      let descriptor: CubiqTS.ApplicationNotificationFetchDescriptorImpl =
        new CubiqTS.ApplicationNotificationFetchDescriptorImpl();
      descriptor.eventType = this.mapDescriptorType(eventType);
      if (descriptor.eventType == null) {
        logger.out.warn(`appn-s - Unsupported eventType: ${eventType}`);
        continue;
      }
      if (
        eventType === BFXAppNotificationType.APP_BMARK_FILLED ||
        eventType === BFXAppNotificationType.APP_BMARK_CANCELLED ||
        eventType === BFXAppNotificationType.APP_BMARK_ENTERED
      ) {
        descriptor.filterName = "BENCHMARK_TYPE_TRADE_FILTER";
      } else if (
        eventType === BFXAppNotificationType.PART_FILLED ||
        eventType === BFXAppNotificationType.FILLED ||
        eventType === BFXAppNotificationType.CANCELLED ||
        eventType === BFXAppNotificationType.EXPIRED ||
        eventType === BFXAppNotificationType.ENTERED
      ) {
        descriptor.filterName = "LIMIT_TYPE_TRADE_FILTER";
      } else if (
        eventType === BFXAppNotificationType.ALGO_PART_FILLED ||
        eventType === BFXAppNotificationType.ALGO_FILLED ||
        eventType === BFXAppNotificationType.ALGO_CANCELLED ||
        eventType === BFXAppNotificationType.ALGO_EXPIRED ||
        eventType === BFXAppNotificationType.ALGO_ENTERED
      ) {
        descriptor.filterName = "ALGO_TYPE_TRADE_FILTER";
      }
      ds.push(descriptor);
    }
    setTimeout(() => {
      this.notificationService.getApplicationNotifications(ds).then((res) => {
        logger.out.info(
          "BfxApplicationNotificationService -> returned " + res.length + " notifications on login",
        );
      });
    }, 1000);
  }

  /**
   * Load audio config for throttling sounds played for a given application
   * notification type. The config represents the minimum interval time in
   * milliseconds between two sequental sounds for the same notification type
   */
  private loadAudioThrottleConfig(): void {
    this.configService.getUIConfig().then((value: BfxUIConfiguration) => {
      let soundThrottleInterval = value?.general?.appNotifSoundThrottleInterval;

      if (soundThrottleInterval == null || typeof soundThrottleInterval != "number") {
        logger.out.error(`${this.constructor.name}: Sound throttle interval unspecified.`);
      } else {
        this.soundThrottleInterval = soundThrottleInterval;
      }

      logger.out.info(`${this.constructor.name}: Sound throttle: ${this.soundThrottleInterval}`);
    });
  }

  private getSystemFlagsAndRolesForActions() {
    return new Promise<any>((res, rej) => {
      Promise.all<any>([
        this.systemConfigService.getSystemConfig(CubiqServices.SysFeatures.fixingOrderLongName), // 0
        this.systemConfigService.getSystemConfig(CubiqServices.SysFeatures.fixingOrderShortName), // 1
      ])
        .then(
          ([bmarkLongName, bmarkShortName]) => {
            this.bmarkLongName = bmarkLongName != null ? bmarkLongName.toUpperCase() : "BENCHMARK";
            this.bmarkShortName = bmarkShortName != null ? bmarkShortName.toUpperCase() : "BMARK";
            res(true);
          },
          (rejection) => {
            logger.out.error(
              "ERROR:BfxApplicationNotificationService systemConfigService rejection:",
              rejection,
            );
            rej(false);
          },
        )
        .catch((reason) => {
          logger.out.error(
            "ERROR:BfxApplicationNotificationService systemConfigService reason: ",
            reason,
          );
          rej(false);
        });
    });
  }

  setPaginatorCallbackFunction(fn: Function): void {
    this.pagResetCallback = fn;
  }

  // *********************************************************************************** //
  // Configuration for each of the event types needs to be put into the following        //
  //                                                                                     //
  // *********************************************************************************** //

  // create the notification from an order payload
  createOrderNotificationData(notifEvent: INotificationEvent): BfxApplicationNotificationData {
    let notification: BfxApplicationNotificationData = this.getNotificationDataByType(
      notifEvent.notifType,
      notifEvent.notifSubType,
    );
    let order: any = notifEvent.orderNotifData as CubiqServices.IOrderNotifData;
    let isBmarkOrder =
      order.requestedOrderType ===
      (CubiqTS.RequestOrderType.BMARK || CubiqTS.RequestOrderType.BMALGO);

    let amount: string =
      notifEvent.notifSubType === BFXNotificationSubType.FILL_FULL
        ? order.dealtTotalAmt
        : order.dealtTruncatedAmt;

    notification.eventType = BFXAppNotificationEventType.ORDER_UPDATE_EVENT;
    if (order.requestedOrderType !== CubiqTS.RequestOrderType.CALL && !isBmarkOrder) {
      order.as_notify_main_body = notification.body =
        order.instrument +
        " " +
        order.clientIntent +
        " " +
        amount +
        " " +
        order.fixedCode +
        " " +
        order.dealtTrackingRate;
      order.as_notify_body = amount + " " + order.fixedCode;
    } else if (isBmarkOrder) {
      order.as_notify_main_body = notification.body =
        order.instrument + " " + order.clientIntent + " " + amount;
      order.as_notify_body = amount + " " + order.fixedCode;
    } else {
      order.as_notify_main_body = notification.body =
        order.instrument + " " + order.clientIntent + " " + order.dealtTrackingRate;
    }
    notification.bodyType = order.requestedOrderTypeAsString;

    // ORDER ENTERED notifications have the algo type as type
    try {
      if (
        order.fullOrderDataObj != null &&
        ((notifEvent.notifType === BFXNotificationType.LIMITALGO_ORDER_ENTERED &&
          order.fullOrderDataObj.orderType === CubiqTS.OrderType.ALGO) ||
          (notifEvent.notifType === BFXNotificationType.BMARK_ORDER_ENTERED &&
            order.fullOrderDataObj.orderType === CubiqTS.OrderType.BMALGO) ||
          notifEvent.notifType === BFXNotificationType.ALGO_LIMITALGO_ORDER_ENTERED)
      ) {
        let algoName = this.orderTypeHelper.getAlgoStrategyDescription(order.fullOrderDataObj);
        order.as_notify_requestedOrderType = algoName;
        notification.bodyType = algoName;
      }
    } catch (e) {
      logger.out.error(
        `${this.constructor.name}: Error updating order type for entry` +
          ` notification for order ${order.as_notify_id}: ${e}`,
        e,
      );
    }

    // BENCHMARK ORDER ENTERED notifications have the fixing as type
    try {
      if (
        order.fullOrderDataObj != null &&
        (notifEvent.notifType === BFXNotificationType.BMARK_ORDER_ENTERED ||
          notifEvent.notifType === BFXNotificationType.BMARK_FILLED) &&
        order.fullOrderDataObj.orderType === CubiqTS.OrderType.BENCHMARK &&
        order.fullOrderDataObj.fixingDetails?.reqFixingCd != null
      ) {
        let fixingTime = order.fullOrderDataObj.fixingDetails?.reqFixingCd;
        order.as_notify_requestedOrderType = fixingTime;
        notification.bodyType = fixingTime;
      }
    } catch (e) {
      logger.out.error(
        `${this.constructor.name}: Error updating order type for entry` +
          ` notification for order ${order.as_notify_id}: ${e}`,
        e,
      );
    }

    // //populated for multiple items view table
    order.as_notify_time = order.orderDate;
    order.as_notify_instrument = order.instrument;
    order.as_notify_clientIntent = order.clientIntent;
    order.as_notify_dealtTracking = isBmarkOrder ? " " : order.dealtTrackingRate;
    order.as_notify_id = order.orderId.toString();
    order.as_notify_ref = order.orderRef;
    order.as_notify_requestedOrderType = order.requestedOrderType;

    order.as_notify_footerAction = BfxApplicationNotificationCommand.POPUP_VIEW_ORDER;

    notification.addToPayload(order);
    if (
      order.fullOrderDataObj.orderType === (CubiqTS.OrderType.BENCHMARK || CubiqTS.OrderType.BMALGO)
    ) {
      notification.title = this.translationService.instant(
        "popup.notification.title." + notification.typeStr,
        [this.bmarkShortName],
      );
    } else {
      notification.title = this.translationService.instant(
        "popup.notification.title." + notification.typeStr,
      );
    }
    notification.time = Number(
      order.fullOrderDataObj.txTime != null
        ? order.fullOrderDataObj.txTime.format("x")
        : Date.now(),
    );

    notification.footer = order.clientName;
    notification.footerAction = order.as_notify_footerAction;

    return notification;
  }

  createDealNotificationData(notifEvent: INotificationEvent): BfxApplicationNotificationData {
    let notification: BfxApplicationNotificationData = this.getNotificationDataByType(
      notifEvent.notifType,
      notifEvent.notifSubType,
    );
    let deal: any = notifEvent.tradeNotifData as CubiqServices.ITradeNotifData;
    notification.eventType = BFXAppNotificationEventType.DEAL_UPDATE_EVENT;
    if (notification instanceof BfxApplicationNotificationData) {
      notification.idField = "id";
      if (deal.requestOrderType !== CubiqTS.RequestOrderType.CALL) {
        deal.as_notify_main_body =
          deal.productId +
          " " +
          deal.isBuy +
          " " +
          deal.truncatedDealtAmount +
          " " +
          deal.dealtCcy +
          " " +
          deal.allInClientRate;
        deal.as_notify_body = deal.truncatedDealtAmount + " " + deal.dealtCcy + " ";
      } else {
        deal.as_notify_main_body =
          deal.productId + " " + deal.requestOrderTypeAsString + " " + deal.allInClientRate;
      }
      notification.body = deal.as_notify_main_body;

      //populated for multiple items view table
      deal.as_notify_time = deal.dealDate;
      deal.as_notify_instrument = deal.productId;
      deal.as_notify_clientIntent =
        deal.requestOrderType !== CubiqTS.RequestOrderType.CALL
          ? deal.isBuy
          : deal.requestOrderTypeAsString;
      deal.as_notify_dealtTracking = deal.allInClientRate;
      deal.as_notify_id = deal.id.toString();
      deal.as_notify_ref = deal.dealRef;
      deal.as_notify_requestedOrderType = deal.requestOrderTypeAsString;
      deal.as_notify_notificationSettleDate = deal.as_search_valueDate;
      deal.as_notify_footerAction = BfxApplicationNotificationCommand.POPUP_VIEW_DEAL;
      notification.addToPayload(deal);

      notification.title = this.translationService.instant(
        "popup.notification.title." + notification.typeStr,
      );
      notification.time = Number(
        CubiqTS.moment.isMoment(deal?.completeTradeDeal?.transactTime)
          ? deal?.completeTradeDeal?.transactTime.format("x")
          : Date.now(),
      );
      notification.bodyType = deal.requestOrderTypeAsString;
      notification.footer = deal.clientName;
      notification.footerAction = deal.as_notify_footerAction;

      return notification;
    } else {
      logger.out.error(
        `ERROR: ${this.constructor.name}.createDealNotificationData(): Failed to create notificationData object for type: ${notifEvent.notifType}`,
      );
      return null;
    }
  }

  getNotificationDataByType(
    type: BFXNotificationType,
    subType: BFXNotificationSubType,
  ): BfxApplicationNotificationData {
    switch (type) {
      case BFXNotificationType.CANCELLED:
        return new BfxApplicationNotificationData(BFXAppNotificationType.CANCELLED, "icon-close");
      case BFXNotificationType.EXPIRED:
        return new BfxApplicationNotificationData(
          BFXAppNotificationType.EXPIRED,
          "icon-bfx_expired",
        );
      case BFXNotificationType.SUSPENDED:
        return new BfxApplicationNotificationData(
          BFXAppNotificationType.SUSPENDED,
          "icon-pause_circle",
        );
      case BFXNotificationType.PART_FILLED:
      case BFXNotificationType.FILLED:
        let appSubType: BFXAppNotificationSubType = undefined;
        if (subType === BFXNotificationSubType.FILL_FULL)
          appSubType = BFXAppNotificationSubType.FILL_FULL;
        else if (subType === BFXNotificationSubType.FILL_PART)
          appSubType = BFXAppNotificationSubType.FILL_PART;
        return new BfxApplicationNotificationData(
          BFXAppNotificationType.FILLED,
          "icon-check_circle",
          appSubType,
        );
      case BFXNotificationType.BMARK_FILLED:
        let appBmarkSubType: BFXAppNotificationSubType = undefined;
        if (subType === BFXNotificationSubType.FILL_FULL)
          appBmarkSubType = BFXAppNotificationSubType.FILL_FULL;
        else if (subType === BFXNotificationSubType.FILL_PART)
          appBmarkSubType = BFXAppNotificationSubType.FILL_PART;
        return new BfxApplicationNotificationData(
          BFXAppNotificationType.APP_BMARK_FILLED,
          "icon-check_circle",
          appBmarkSubType,
        );
      case BFXNotificationType.MODIFIED:
        return new BfxApplicationNotificationData(BFXAppNotificationType.MODIFIED, "icon-edit");
      case BFXNotificationType.BMARK_MODIFIED:
        return new BfxApplicationNotificationData(
          BFXAppNotificationType.APP_BMARK_MODIFIED,
          "icon-edit",
        );
      case BFXNotificationType.ACTIVATED:
        return new BfxApplicationNotificationData(
          BFXAppNotificationType.ACTIVATED,
          "icon-bfx_activated",
        );
      case BFXNotificationType.LIMITALGO_ORDER_ENTERED:
        return new BfxApplicationNotificationData(
          BFXAppNotificationType.ENTERED,
          "icon-bfx_activated",
        );
      case BFXNotificationType.BMARK_ORDER_ENTERED:
        return new BfxApplicationNotificationData(
          BFXAppNotificationType.APP_BMARK_ENTERED,
          "icon-bfx_activated",
        );
      case BFXNotificationType.BMARK_CANCELLED:
        return new BfxApplicationNotificationData(
          BFXAppNotificationType.APP_BMARK_CANCELLED,
          "icon-close",
        );
      default:
        return null;
    }
  }

  // actions recieved from the popups need to call their appropriate action service
  private openDialogAttachSubscription(appData: BfxApplicationNotificationData): void {
    appData
      .subscribeForCommand()
      .subscribe(
        (action: {
          command: BfxApplicationNotificationCommand;
          appData: BfxApplicationNotificationData;
        }) => {
          let bae: BfxBlotterActionEvent;
          switch (action.command) {
            case BfxApplicationNotificationCommand.POPUP_CLOSE:
              this.closeDialog(appData.payloadIds[0]);
              break;
            case BfxApplicationNotificationCommand.POPUP_VIEW_DEAL:
              bae = new BfxBlotterActionEvent(
                BfxBlotterAction.ACTION_TRADE_VIEW_TRADE_DETAILS,
                null,
                appData.payloadIds,
                appData.payload,
              );
              this.blotterTradeActionService.onViewTradeDetails(bae);
              break;
            case BfxApplicationNotificationCommand.POPUP_VIEW_ORDER:
              bae = new BfxBlotterActionEvent(
                BfxBlotterAction.ACTION_VIEW_DETAILS,
                null,
                appData.payloadIds,
                appData.payload,
              );
              this.blotterOrderActionService.onOrderDetails(bae);
              break;
            case BfxApplicationNotificationCommand.POPUP_VIEW_DI:
              // bae=new BfxBlotterActionEvent(BfxBlotterAction.ACTION_DI_VIEW_DETAILS,null,appData.payloadIds,appData.payload);
              // bae.itemState=appData['itemState'];
              // bae.itemState["referencedOrderIds"]=appData.payloadIds;
              // this.blotterInterventionActionService.onViewDetails(bae);
              break;
          }
        },
      );
  }

  // load the app notification settings, if they are not saved to the profile, we need to load a default per user, that last part still needs to be completed
  private initializeNotificationSubscriptions() {
    this.orderUpdateSubscription = this.notificationService
      .getAppNotificationSubject(BFXAppNotificationEventType.ORDER_UPDATE_EVENT)
      .subscribe(this.onOrderNotificationEvent.bind(this));
    this.dealUpdateSubscription = this.notificationService
      .getAppNotificationSubject(BFXAppNotificationEventType.DEAL_UPDATE_EVENT)
      .subscribe(this.onDealNotificationEvent.bind(this));
  }

  // notifications we recieve from the workier,
  protected onOrderNotificationEvent(row: INotificationEvent): void {
    try {
      let notifSetting = this.appSettingProviderService.getNotificationSetting(row);

      if (notifSetting != null) {
        let filter: BfxBlotterFilter = notifSetting.filter
          ? this.filterService.getBlotterFilterSync(notifSetting.filter.id)
          : null;
        let orderData: OrderDataImpl =
          row.orderNotifData != null ? row.orderNotifData.fullOrderDataObj : null;

        if (!filter || this.doesOrderFilterPass(orderData, filter)) {
          this.addNotification(this.createOrderNotificationData(row));
          if (notifSetting.disableAllAudio === false && this.shouldBePlayed(notifSetting.type)) {
            this.soundsService.playSoundById(notifSetting.audio.label);
          }
        }
      }
    } catch (ex) {
      logger.out.error(
        `ERROR: ${this.constructor.name}.onOrderNotificationEvent(): EXCEPTION: ${ex}`,
      );
    }
  }

  // does the order we recieved from the worker pass the filter? if no filter it will pass
  public doesOrderFilterPass(data: any, filter: BfxBlotterFilter): boolean {
    try {
      if (filter != null) {
        if (data.orderType === (CubiqTS.OrderType.BENCHMARK || CubiqTS.OrderType.BMALGO)) {
          return this.bmarkClientOrdersFilterService.doFiltersPass(data, [filter], true);
        } else {
          return this.orderFilteringService.doFiltersPass(data, [filter]);
        }
      }
    } catch (error) {
      logger.out.error("Error while doing a order filter pass.", error);
    }

    return true;
  }

  // notifications we recieve from the workier,
  protected onDealNotificationEvent(row: INotificationEvent): void {
    try {
      //logger.out.warn(`INFO: ${this.constructor.name}.onDealNotificationEvent() => [${row.tradeNotifData.orderId + ' - ' + row.tradeNotifData.dealState}] `, row);
      let notifSetting = this.appSettingProviderService.getNotificationSetting(row);
      if (notifSetting != null) {
        let filter: BfxBlotterFilter = notifSetting.filter
          ? this.filterService.getBlotterFilterSync(notifSetting.filter.id)
          : null;

        if (!filter || this.doesDealFilterPass(row, filter)) {
          this.addNotification(this.createDealNotificationData(row));
          if (notifSetting.disableAllAudio === false && this.shouldBePlayed(notifSetting.type)) {
            this.soundsService.playSoundById(notifSetting.audio.label);
          }
        }
      }
    } catch (ex) {
      logger.out.error(
        `ERROR: ${this.constructor.name}.onDealNotificationEvent(): EXCEPTION: ${ex}`,
      );
    }
  }

  // does the order we recieved from the worker pass the filter? if no filter it will pass
  public doesDealFilterPass(data: any, filter: BfxBlotterFilter): boolean {
    try {
      if (filter != null) {
        if (data.notifType === BFXNotificationType.BMARK_FILLED) {
          return this.bmarkClientOrdersFilterService.doFiltersPass(data, [filter]);
        } else {
          return this.dealFilteringService.doFiltersPass(data, [filter]);
        }
      }
    } catch (error) {
      logger.out.error("Error while doing a order filter pass.", error);
    }

    return true;
  }

  public addNotification(appData: BfxApplicationNotificationData) {
    if (appData && !this.isExistingNotification(appData)) {
      this.openDialogAttachSubscription(appData);
      this.notifications.push(appData);
      this.notifications.sort(NOTIF_SORT);
      this._notifyCounterSubject.next({
        notifCounter: this.notifications.length,
      });
    }
  }

  protected isExistingNotification(appData: BfxApplicationNotificationData) {
    let exists: boolean = false;

    if (Array.isArray(appData.payloadIds) && appData.payloadIds.length == 1) {
      let payloadId = appData.payloadIds[0];
      exists =
        this.notifications
          .filter((n) => Array.isArray(n.payloadIds) && n.payloadIds.length == 1)
          .find((n) => n.typeStr === appData.typeStr && n.payloadIds[0] === payloadId) != null;
    }

    return exists;
  }

  public getNotificationCounterSubject(): Subject<{ notifCounter: number }> {
    return this._notifyCounterSubject;
  }

  getApplicationNotifications(): Array<BfxApplicationNotificationData> {
    return this.notifications;
  }

  public closeAllNotifications(): void {
    this.notifications.splice(0);
    this._notifyCounterSubject.next({
      notifCounter: this.notifications.length,
    });
  }

  private closeDialog(_dialogId: string): void {
    let notif: any = this.notifications.find((a) => {
      return a.payloadIds[0] == _dialogId;
    });
    if (notif !== undefined) {
      this.notifications.splice(this.notifications.indexOf(notif), 1);
      this._notifyCounterSubject.next({
        notifCounter: this.notifications.length,
      });
    }
  }

  /**
   * Checks the time interval for when an audio for a given app notification
   * type was played.
   * @param notifType application notification type
   * @returns true if sound was played longer than the minimum period or sound for
   * this type hasn't played yet
   */
  private shouldBePlayed(notifType: BFXAppNotificationType): boolean {
    let lastTimestamp = this.appNotifAudioTimestamps[notifType];
    let currentTimestamp = Date.now();

    let shouldPlay = false;

    if (lastTimestamp == null || currentTimestamp - lastTimestamp > this.soundThrottleInterval) {
      shouldPlay = true;
      this.appNotifAudioTimestamps[notifType] = currentTimestamp;
    }

    return shouldPlay;
  }

  /**
   *  For login notifications, map the notification type to the event type defined on the server. This is used
   * to map different logic types (CANCELLED, ALGO_CANCELLED, BMARK_CANCELLED) into a ssingle type used by server
   * @param notifType
   * @returns
   */
  private mapDescriptorType(
    notifType: BFXAppNotificationType,
  ): CubiqTS.ApplicationNotificationEventType {
    switch (notifType) {
      case BFXAppNotificationType.CANCELLED:
      case BFXAppNotificationType.APP_BMARK_CANCELLED:
      case CubiqServices.BFXAppNotificationType.ALGO_CANCELLED:
        return CubiqTS.ApplicationNotificationEventType.CANCELLED;
      case BFXAppNotificationType.PART_FILLED:
      case CubiqServices.BFXAppNotificationType.ALGO_PART_FILLED:
        return CubiqTS.ApplicationNotificationEventType.PART_FILLED;
      case BFXAppNotificationType.FILLED:
      case BFXAppNotificationType.APP_BMARK_FILLED:
      case CubiqServices.BFXAppNotificationType.ALGO_FILLED:
        return CubiqTS.ApplicationNotificationEventType.FILLED;
      case BFXAppNotificationType.EXPIRED:
      case CubiqServices.BFXAppNotificationType.ALGO_EXPIRED:
        return CubiqTS.ApplicationNotificationEventType.EXPIRED;
      case BFXAppNotificationType.ENTERED:
      case BFXAppNotificationType.APP_BMARK_ENTERED:
      case CubiqServices.BFXAppNotificationType.ALGO_ENTERED:
        return CubiqTS.ApplicationNotificationEventType.ENTERED;
      default:
        // We only support those setting above that are used for Login
        return null;
    }
  }

  public paginatorReset(): void {
    this.pagResetCallback();
  }
}
